import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { RelatorioDemonstrativoReceitaDespesaResponse, FiltroRelatorioReceitaDespesa } from "../typings";
import http  from 'infra/http';

export function useRelatorioDemonstrativoReceitaDespesa(query: FiltroRelatorioReceitaDespesa) {
  return useQuery<RelatorioDemonstrativoReceitaDespesaResponse, AxiosError>(
    ['/v1/relatorios/financeiro/demonstrativo-receita-despesa', query],
    async () => {
      const {data} = await http.get('/v1/relatorios/financeiro/demonstrativo-receita-despesa', {
        params: query
      })

      return data;
    }
  );
}
